import loadable from '@loadable/component';

export const CmsDonateBlockLoadable = loadable(
  () => import('./CmsDonateBlock'),
  { resolveComponent: (module) => module.CmsDonateBlock },
);
